import { EmploymentHistorySchema } from 'schemas/history'
import { ListIndustrySchema } from 'schemas/listItem.schema'
import SkillSchema from 'schemas/skill.schema'
import { z } from 'zod'

import { checkFieldOnDateValid } from 'utils/schema.util'

export const CVStepWorkIndustriesSchema = z.object({
  industries: ListIndustrySchema.array().min(1, {
    message: 'custom.select1Industry'
  })
})

const cVStepWorkExperienceSchema = CVStepWorkIndustriesSchema.extend({
  employmentHistory: EmploymentHistorySchema.extend({
    skills: SkillSchema.array().min(1, { message: 'custom.select1Skill' }),
    description: z
      .string()
      .nullable()
      .optional()
      .transform((v) => v || null)
  })
    .superRefine(checkFieldOnDateValid)
    .array()
    .min(1, { message: 'custom.atLeast1WorkExperience' })
})

export default cVStepWorkExperienceSchema
